// 需要在包裹的子元素上添加额外的scroll-animate-item类名
/*  整段上浮 
  <scroll-animate>
  <div class="scroll-animate-item">A</div>
  </scroll-animate>
*/
/*  多段上浮
  <scroll-animate>
  <div class="scroll-animate-item">A</div>
  <div class="scroll-animate-item">B</div>
  <div class="scroll-animate-item">c</div>
</scroll-animate>
*/

/* 调整多段上浮时间，不写默认0.1秒
  <scroll-animate step-delay="0.3"> 
    <div class="scroll-animate-item">A</div>
    <div class="scroll-animate-item">B</div>
    <div class="scroll-animate-item">c</div>
  </scroll-animate>
*/
class ScrollAnimate extends HTMLElement {
    constructor() {
      super();
      this.stepDelay = parseFloat(this.getAttribute('step-delay')) || 0.1;
      this.selector = this.getAttribute('selector') || '.scroll-animate-item';
      this.observer = null;
      this.animationFrameId = null;
      this.isAnimating = false;
    }
  
    connectedCallback() {
      requestAnimationFrame(() => this.initObserver());
    }
  
    disconnectedCallback() {
      // 清理 observer
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      // 取消动画
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    }
  
    initObserver() {
      const animElements = Array.from(this.querySelectorAll(this.selector));
  
      if (!animElements.length) return;
  
      const thresholdValue = 0.1;
  
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isAnimating) {
            this.isAnimating = true;
            this.animateElements(animElements);
            this.observer.unobserve(entry.target);
          }
        });
      }, { threshold: thresholdValue });
  
      this.observer.observe(this);
    }
  
    /**
     * 使用 requestAnimationFrame 实现延迟动画
     * @param {HTMLElement[]} elements - 需要动画的元素数组
     */
    animateElements(elements) {
      const stepDelayMs = this.stepDelay * 1000;
      let currentIndex = 0;
      let startTime = null;
  
      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
  
        const elapsed = timestamp - startTime;
        const targetIndex = Math.floor(elapsed / stepDelayMs);
  
        // 添加所有应该显示的元素的类名
        while (currentIndex <= targetIndex && currentIndex < elements.length) {
          elements[currentIndex].classList.add('animate_visible');
          currentIndex++;
        }
  
        // 如果还有元素未显示，继续动画
        if (currentIndex < elements.length) {
          this.animationFrameId = requestAnimationFrame(animate);
        } else {
          this.animationFrameId = null;
        }
      };
  
      this.animationFrameId = requestAnimationFrame(animate);
    }
  }
  
  customElements.define('scroll-animate', ScrollAnimate);
  